module.exports = __webpack_public_path__ + "img/unused_Logo_white_border.10daf772.svg";